"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleFilledWithOuterRing = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CircleFilledWithOuterRing = function (_a) {
    var id = _a.id;
    var clipPathId = id
        ? "CircleFilledWithOuterRing__clip0__".concat(id)
        : 'CircleFilledWithOuterRing__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", d: "M12 6c-3.312 0-6 2.688-6 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zm0-6C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zm0 21.6A9.597 9.597 0 012.4 12c0-5.304 4.296-9.6 9.6-9.6 5.304 0 9.6 4.296 9.6 9.6 0 5.304-4.296 9.6-9.6 9.6z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "currentColor", d: "M0 0H24V24H0z" })))));
};
exports.CircleFilledWithOuterRing = CircleFilledWithOuterRing;
//# sourceMappingURL=circle-filled-with-outer-ring.js.map